<template>
  <div>
    <v-tabs
      v-if="showTabs"
      background-color="transparent"
      color="primary"
      centered
      hide-slider
      class="mt-6"
    >
      <v-tab v-for="(tab, i) in categories" :key="i" :to="tab.to">{{
        tab.name
      }}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: "AppLinks",

  components: {
    // Reports
  },
  data: () => ({
    showTabs: true,
    reportShow: false,
    items: [
      {
        title: "Akademsko osoblje",
        to: "/radovi",
      },
    ],
    categories: [
      {
        name: "Radovi",
        to: "/",
      },
      {
        name: "Autori",
        to: "/autori",
      },
      {
        name: "Izdavači",
        to: "/izdavaci",
      },
      {
        name: "Izdanja",
        to: "/izdanja",
      },
      {
        name: "Baze izdanja",
        to: "/baze_izdanja",
      },
      {
        name: "Znanstvena područja",
        to: "/znanstvena_podrucja",
      },
      {
        name: "Tipovi rada",
        to: "/tipovi_radova",
      },
    ],
  }),

  computed: {},
};
</script>

<style scoped>
</style>